import React from "react";
import PropTypes from "prop-types";

import CountUp from "react-countup";
import isEmpty from "lodash/isEmpty";
import Grid from "../styled/Grid";

const ContractMetrics = ({ contract, projects, calls, hours }) => {
  let hourBalance = 0;
  let balanceAmount = 0;

  const round = (n, decimals = 1) =>
    Number(`${Math.round(`${n}e${decimals}`)}e-${decimals}`);

  const callsToUse = calls.filter((call) => {
    const d1 = new Date(call.completed_date).getTime();
    const d2 = new Date(2016, 0).getTime();
    return d1 >= d2;
  });

  const purchasedHours =
    !isEmpty(contract) &&
    contract.purchase_orders.reduce(
      (total, po) => total + po.hours_purchased,
      0
    );

  const purchasedAmount =
    !isEmpty(contract) &&
    contract.purchase_orders.reduce((total, po) => total + po.amount, 0);

  const legacyATD = projects.reduce(
    (total, project) => total + project.legacy_atd,
    0
  );
  const legacyBTD = projects.reduce(
    (total, project) => total + project.legacy_btd,
    0
  );

  let actualHours = callsToUse.reduce(
    (total, call) => total + call.actual_hrs,
    0
  );

  actualHours += legacyATD || 0;

  const actualAmount = callsToUse.reduce(
    (total, call) => total + (call.actual_hrs || 0) * call.project.rate,
    0
  );

  let billableHours = callsToUse.reduce(
    (total, call) => total + (call.billable_hrs || 0),
    0
  );
  billableHours += legacyBTD || 0;

  const billableAmount = callsToUse.reduce(
    (total, call) => total + (call.billable_hrs || 0) * call.project.rate,
    0
  );

  hourBalance = purchasedHours - billableHours || 0;
  balanceAmount = purchasedAmount - billableAmount;

  const metrics = [
    {
      label: `Purchased ${hours ? "(Hrs)" : "($)"}`,
      end: round(!hours ? purchasedAmount : purchasedHours, 1)
    },
    {
      label: `Actual ${hours ? "(Hrs)" : "($)"}`,
      end: round(!hours ? actualAmount : actualHours, 1)
    },
    {
      label: `Billable ${hours ? "(Hrs)" : "($)"}`,
      end: round(!hours ? billableAmount : billableHours, 1)
    },
    {
      label: `Balance ${hours ? "(Hrs)" : "($)"}`,
      end: round(!hours ? balanceAmount : hourBalance, 1)
    }
  ];

  return (
    !isEmpty(contract) && (
      <Grid className="contract" style={{ marginTop: "10px" }}>
        {metrics.map((data, idx) => (
          <div key={idx} className="content-wrapper">
            <fieldset>
              <legend>{data.label}</legend>
            </fieldset>
            <CountUp
              className="counter"
              suffix={data.suffix}
              prefix={data.prefix}
              decimals={2}
              separator=","
              end={data.end}
            />
          </div>
        ))}
      </Grid>
    )
  );
};

ContractMetrics.propTypes = {
  calls: PropTypes.array,
  contract: PropTypes.object,
  projects: PropTypes.array,
  hours: PropTypes.number
};
ContractMetrics.defaultProps = {
  calls: []
};
export default ContractMetrics;
